import cloneDeep from 'lodash-es/cloneDeep';
import { ComponentsAction, ComponentsActionType } from './Components.action-types';
import { IComponentsState } from './Components.types';

const initialState: IComponentsState = {
  components: null,
  errorMessage: null,
  isLoading: false,
};

export function componentsReducer(state: IComponentsState = initialState, action: ComponentsAction): IComponentsState {
  switch (action.type) {
    case ComponentsActionType.REQUEST_COMPONENTS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ComponentsActionType.RECEIVE_COMPONENTS: {
      return {
        ...state,
        isLoading: false,
        components: action.components,
      };
    }
    default:
      return state;
  }
}
